import React from 'react';
import { useDispatch } from 'react-redux';
import Icon from 'mdi-react/LogoutIcon';
import { logoutRequest } from '../../store/app/actions';
import { captureButtonPress } from '../../features/analytics';
import { HEADER_BUTTON_SIZE } from '../../style/SIZES';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../style/styled';
import {
  AppHeaderButtonContainer,
  AppHeaderButtonText,
} from './styledComponents';
interface Props {
  color?: string;
  size?: number;
  fullWidth?: boolean;
}

export const SignOutLink: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();

  const color = props.color || theme.palette.appHeader.color;
  const size = props.size || HEADER_BUTTON_SIZE;
  const fullWidth = props.fullWidth || false;

  return (
    <AppHeaderButtonContainer
      fullWidth={fullWidth}
      onClick={() => {
        captureButtonPress({
          page: window.location.pathname,
          buttonName: 'LogOut',
        });

        dispatch(logoutRequest({}));
      }}
    >
      <Icon color={color} size={size * 1.4} />
      <AppHeaderButtonText size={size} color={color}>
        {t('Log out')}
      </AppHeaderButtonText>
    </AppHeaderButtonContainer>
  );
};
